'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { KeyboardArrowDown } from '@mui/icons-material';
import { PAGE_LABEL, PAGE_NAME } from '@/constants/navigation.constants';
import { useNavigationLogic } from '@/hooks/useNavigationLogic';
import { TextButton } from '@/shared/ui/atoms';
import NavigationDropdown from '@/shared/ui/molecules/NavigationDropdown';

const DesktopNavigations = () => {
  const router = useRouter();
  const { pathname, appStoreId, hasToken, isOwnerOrAdmin, getNavigationItem, getMediContentsPath } = useNavigationLogic();
  const [openDropdown, setOpenDropdown] = useState<number | null>(null);

  return (
    <nav className="w-full flex flex-row items-center gap-2">
      <div className="relative" onMouseEnter={() => setOpenDropdown(1)} onMouseLeave={() => setOpenDropdown(0)}>
        <button
          className={`flex items-center gap-1 py-[6px] px-[14px] text-[#2E2F33] text-[16px] leading-[24px] tracking-[0.32px] cursor-pointer transition-all ${
            openDropdown === 1 ? 'font-bold' : 'font-medium'
          }`}
        >
          리뷰매니저
          <KeyboardArrowDown className="text-[#2E2F33]" sx={{ fontSize: '20px' }} />
        </button>
        {openDropdown === 1 && (
          <NavigationDropdown
            items={[
              { pageName: PAGE_NAME.ENTERPRISE, label: PAGE_LABEL[PAGE_NAME.ENTERPRISE] },
              { pageName: PAGE_NAME.DASHBOARD, label: PAGE_LABEL[PAGE_NAME.DASHBOARD] },
              { pageName: PAGE_NAME.REVIEWS, label: PAGE_LABEL[PAGE_NAME.REVIEWS] }
            ]}
            getNavigationItem={getNavigationItem}
            appStoreId={appStoreId}
            pathname={pathname}
          />
        )}
      </div>

      <div className="relative" onMouseEnter={() => setOpenDropdown(2)} onMouseLeave={() => setOpenDropdown(0)}>
        <button
          className={`flex items-center gap-1 py-[6px] px-[14px] text-[#2E2F33] text-[16px] leading-[24px] tracking-[0.32px] cursor-pointer transition-all ${
            openDropdown === 2 ? 'font-bold' : 'font-medium'
          }`}
        >
          리뷰부스터
          <KeyboardArrowDown className="text-[#2E2F33]" sx={{ fontSize: '20px' }} />
        </button>
        {openDropdown === 2 && (
          <NavigationDropdown
            items={[
              { pageName: PAGE_NAME.REVIEW_BOOSTER_LANDING, label: PAGE_LABEL[PAGE_NAME.REVIEW_BOOSTER_LANDING] },
              ...(hasToken ? [{ pageName: PAGE_NAME.REVIEW_BOOSTER, label: PAGE_LABEL[PAGE_NAME.REVIEW_BOOSTER] }] : [])
            ]}
            getNavigationItem={getNavigationItem}
            appStoreId={appStoreId}
            pathname={pathname}
          />
        )}
      </div>

      <div className="relative" onMouseEnter={() => setOpenDropdown(3)} onMouseLeave={() => setOpenDropdown(0)}>
        <button
          className={`flex items-center gap-1 py-[6px] px-[14px] text-[#2E2F33] text-[16px] leading-[24px] tracking-[0.32px] cursor-pointer transition-all ${
            openDropdown === 3 ? 'font-bold' : 'font-medium'
          }`}
        >
          메디컨텐츠
          <KeyboardArrowDown className="text-[#2E2F33]" sx={{ fontSize: '20px' }} />
        </button>
        {openDropdown === 3 && (
          <NavigationDropdown
            items={[
              { pageName: PAGE_NAME.MEDICONTENTS_LANDING, label: PAGE_LABEL[PAGE_NAME.MEDICONTENTS_LANDING] },
              ...(hasToken ? [{ pageName: PAGE_NAME.MEDICONTENTS, label: PAGE_LABEL[PAGE_NAME.MEDICONTENTS] }] : [])
            ]}
            getNavigationItem={getNavigationItem}
            appStoreId={appStoreId}
            pathname={pathname}
          />
        )}
      </div>

      <TextButton
        label={PAGE_LABEL[PAGE_NAME.BLOG]}
        onClick={() => {
          router.push(getNavigationItem(PAGE_NAME.BLOG, appStoreId));
        }}
        className="text-start py-[6px] px-[14px] text-[#2E2F33] text-[16px] font-medium leading-[24px] tracking-[0.32px] cursor-pointer hover:font-bold transition-all"
      />

      {hasToken && isOwnerOrAdmin && (
        <TextButton
          label={PAGE_LABEL[PAGE_NAME.ORGANIZATION]}
          onClick={() => {
            router.push(getNavigationItem(PAGE_NAME.ORGANIZATION, appStoreId));
          }}
          className={`text-start py-[6px] px-[14px] text-[#2E2F33] text-[16px] leading-[24px] tracking-[0.32px] cursor-pointer transition-all ${
            pathname === getNavigationItem(PAGE_NAME.ORGANIZATION, appStoreId) ? 'font-bold' : 'font-medium hover:font-bold'
          }`}
        />
      )}
    </nav>
  );
};

export default DesktopNavigations;
